import { useEffect, useState } from "react";
import axios from "axios";
import { Area, AreaChart, ResponsiveContainer, YAxis } from "recharts";

const f2 = (v) => (v == null ? "—" : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

const useGold = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/market/gold`).then((r) => setD(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  return d;
};

const Stat = ({ k, v, id }) => (
  <div><div className="text-xs uppercase tracking-widest text-[color:var(--mute)]">{k}</div><div className="tabular-nums mt-1" data-testid={id}>{v}</div></div>
);

export const GtaxLiveGold = () => {
  const d = useGold();
  const up = (d?.change_usd ?? 0) >= 0;
  return (
    <div className="gx-card gx-live p-6 sm:p-7" data-testid="gtax-live-gold">
      <div className="flex items-center justify-between">
        <span className="gx-eyebrow">XAU/USD · Spot</span>
        <span className="flex items-center gap-2 text-xs uppercase tracking-widest text-[color:var(--mute)]" data-testid="gtax-live-status">
          <span className={`w-2 h-2 rounded-full ${d?.market_open === false ? "bg-[color:var(--mute)]" : "bg-emerald-600 gx-pulse"}`} />
          {d?.market_open === false ? "Market closed" : "Live"}
        </span>
      </div>
      <div className="mt-4 flex items-end gap-4 flex-wrap">
        <div className="gx-serif text-5xl tabular-nums" data-testid="gtax-live-price">{d ? `$${f2(d.price)}` : "—"}</div>
        {d?.change_usd != null && (
          <div className={`text-base tabular-nums pb-1 ${up ? "text-emerald-700" : "text-red-700"}`} data-testid="gtax-live-change">
            {up ? "+" : "−"}{f2(Math.abs(d.change_usd))} ({up ? "+" : ""}{d.change_pct}%)
          </div>
        )}
      </div>
      <div className="h-32 mt-4 -mx-2">
        {d?.series?.length > 1 && (
          <ResponsiveContainer>
            <AreaChart data={d.series}>
              <defs><linearGradient id="gxl" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#8F6B22" stopOpacity={0.35} /><stop offset="100%" stopColor="#8F6B22" stopOpacity={0} /></linearGradient></defs>
              <YAxis hide domain={["dataMin", "dataMax"]} />
              <Area type="monotone" dataKey="v" stroke="#8F6B22" strokeWidth={2} fill="url(#gxl)" isAnimationActive={false} />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
      <div className="mt-4 grid grid-cols-3 gap-4 pt-4 border-t border-[color:var(--line)]">
        <Stat k="Range high" v={`$${f2(d?.high)}`} id="gtax-live-high" />
        <Stat k="Range low" v={`$${f2(d?.low)}`} id="gtax-live-low" />
        <Stat k="Updated" v={d?.price_at ? new Date(d.price_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—"} id="gtax-live-time" />
      </div>
      <p className="mt-4 text-xs text-[color:var(--mute)]">Indicative market data from public sources, last 8 hours. Not a quote or an offer.</p>
    </div>
  );
};
